<template>
  <div id="publicAccountUser" style="min-height: calc(100% - 160px);margin: 20px;min-width: 900px;position: relative;">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>通知公众号</el-breadcrumb-item>
      <el-breadcrumb-item>公众号用户</el-breadcrumb-item>
    </el-breadcrumb>
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="用户昵称" :label-width="formLabelWidth2">
            <el-input v-model="nickname" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注名" :label-width="formLabelWidth2">
            <el-input v-model="remark" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="状态" :label-width="formLabelWidth2">
            <el-select v-model="newStatus" placeholder="请选择" size="small">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth2">
            <el-input v-model="shopname" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="检查状态" :label-width="formLabelWidth2">
            <el-select v-model="confirmstatus" placeholder="请选择" size="small">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="theQuery(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    <div class="page">
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @row-click="triggerCli" >
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{scope.$index+1}}
            <div class="redDot" v-show="scope.row.confirmStatus == 0">.</div>
          </template>
        </el-table-column>
        <el-table-column label="用户信息" width="380px">
          <template slot-scope="scope">
            <el-image :src="scope.row.headimgurl" style="width: 55px;height: 55px;float: left;"></el-image>
            <div style="float: left;height: 55px;width: 300px;">
              <div style="margin-left: 5px;float: left;" v-show="scope.row.remark">
                {{ scope.row.remark }}
              </div>
              <div style="margin-left: 5px;float: left;" v-show="scope.row.remark">
                ({{ scope.row.nickname }})
              </div>
              <div style="margin-left: 5px;float: left;" v-show="!scope.row.remark">
                {{ scope.row.nickname }}
              </div>
              <img v-if="scope.row.sex == 1" src="../../assets/img/other/man.png" style="float: left;width: 15px;height: 15px;margin-top: 5px;margin-left: 5px;"></img>
              <img v-if="scope.row.sex == 2" src="../../assets/img/other/woman.png" style="float: left;width: 15px;height: 15px;margin-top: 5px;margin-left: 5px;"></img>
              </br>

              <div class="addTagClass" v-for="(item,index) in scope.row.tagidList" v-show="index < 3"  :key='item.labelName'>
                {{item.labelName}}
              </div>
              <div class="addTagClass" style="cursor: pointer;" @click="addTags(scope.row.tagidList,scope.row.openid)" @click.stop>
                +标签
              </div>
              <el-popover placement="bottom" width="200" trigger="hover">
                <div style="border: 1px solid #108cee;border-radius: 5px;float: left;margin: 5px 0px 0px 5px;color: #108cee;padding: 0 4px 0 4px;font-size: 12px;"
                v-for="(item,index) in scope.row.tagidList">
                  {{item.labelName}}
                </div>
                <div class="addTagMore" slot="reference" v-if="scope.row.tagidList.length > 3">
                  更多
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="province" label="地区">
          <template slot-scope="scope">
            {{scope.row.province}} {{scope.row.city}}
          </template>
        </el-table-column>
        <el-table-column label="关注时间">
          <template slot-scope="scope">
            {{scope.row.subscribe_time | yearMonthDayTime2}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.shopncount > 0">
              已绑定：{{scope.row.shopncount}}家店铺
            </div>
            <div v-else>
              未绑定
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit-outline" @click="oneStep(scope.row.openid,scope.row.nickname,scope.row.remark)" @click.stop>备注</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="this.tableData.length > 1">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 30, 40]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
    <!-- 备注 -->
    <remark @theQuery='theQuery' ref="remark"></remark>
    <!-- 备注 -->
    <!-- 标签 -->
    <setTags  @theQuery='theQuery' ref='refSetTags'></setTags>
    <!-- 标签 -->
    <!-- 侧边详情栏 -->
    <div id="dialog2">
      <el-dialog :visible.sync="centerDialogVisible" width="740px">
        <div class="headBody">
          <div style="float: left;width: 680px;">
            <el-image v-show="this.queryInfoHeadimgurl" :src="this.queryInfoHeadimgurl" style="width: 85px;height: 85px;margin: 7.5px 18px;float:left;"></el-image>
            <div style="line-height: 100px;font-size: 20px;float:left;" v-if="this.queryInfoRemark">
              {{this.queryInfoRemark}} ({{this.queryInfoNickname}})
            </div>
            <div style="line-height: 100px;font-size: 20px;float:left;" v-else>
              {{this.queryInfoNickname}}
            </div>
            <div class="addTagClass" v-for="(item,index) in addTag[sidebarIndex]">
              {{item.tageName}}
            </div>
            <div style="line-height: 100px;font-size: 20px;float: right;margin-right: 40px;" v-if="sjshopname != 0">
              已绑定:{{this.queryInfoDetailData.length}}家店铺
            </div>
            <div style="line-height: 100px;font-size: 20px;float: right;margin-right: 40px;" v-if="sjshopname == 0">
              已绑定:0家店铺
            </div>
          </div>
        </div>
        <el-card class="box-card" v-for="(item,index) in queryInfoDetailData" v-if="item.platform">
          <span v-show="oneInput[index]">
            {{item.shopname}}
          </span>
          <el-input size="small"  v-show="!oneInput[index]" v-model="item.shopname" style="width: 100px;" placeholder="请输入店铺"></el-input>
          <img v-if="item.platform" :src='require("@/assets/img/platform/pla_"+item.platform+".png")' alt style="width: 15px;height: 15px;margin-right: 10px;margin-left: 10px;">
          <span v-show="item.wangwang && twoInput[index]">
            ({{item.wangwang}})
          </span>
          <el-input size="small" v-show="!twoInput[index] && item.platform == 'TB' || !twoInput[index] && item.platform == 'TM' || !twoInput[index] && item.platform == '1688'" v-model="item.wangwang" style="width: 100px;" placeholder="请输入旺旺名"></el-input>
          <el-button type="text" v-show="!oneInput[index]" icon="el-icon-close" style="font-size:16px;margin-left: 100px;" @click="noUpdateShop(index)"></el-button>
          <el-button type="text" v-show="!oneInput[index]" icon="el-icon-check" style="font-size:16px;" @click="updateShop(item.fansid,item.shopname,item.wangwang,index)"></el-button>
          <i class="el-icon-edit-outline" style="float: right;margin-left: 20px;font-size: 25px;margin-top: 4px;color: #108cee;cursor:pointer;" @click="amend(index)"></i>
          <el-button style="float: right;" type="danger" plain size="small" v-show="item.confirm == 0" @click="updateConfirm(item.fansid)">待检查</el-button>
          <el-button style="float: right;" type="success" plain size="small" v-show="item.confirm == 1">已检查</el-button>
        </el-card>
      </el-dialog>
    </div>
    <!-- 侧边详情栏 -->
  </div>
</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  import remark from './remark';
  import setTags from '../../components/weChat/setTags'
  export default {
    data() {
      return {
        sjshopname: '',
        oneInput: [],
        twoInput: [],
        addTag: {},
        sidebarIndex: '',
        options: [{
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '已绑定'
        }, {
          value: '0',
          label: '未绑定'
        }],
        options2: [{
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '已检查'
        }, {
          value: '0',
          label: '待检查'
        }],
        updateOpenid: '',
        confirmstatus: '',
        newShopname: '',
        src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
        centerDialogVisible: false,
        nickname: '',
        queryInfoHeadimgurl: '',
        queryInfoNickname: '',
        queryInfoRemark: '',
        queryInfoShopncount: '',
        tableData: [],
        multipleSelection: [],
        queryInfoDetailData: [],
        remark: '',
        shopname: '',
        newStatus: '',
        totalNum: 100,
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        openNumber: 0,
        formLabelWidth: '80px',
        formLabelWidth2: '100px',

      }
    },
    mounted() {
      this.theQuery();
    },
    methods: {
      // 添加弹框回显处理
      addTags(tagidList,openid) {
         this.$refs.refSetTags.addTagsfun(tagidList,openid)
      },
      amend(e) {
        this.$set(this.oneInput,e,false);
        this.$set(this.twoInput,e,false);
      },
      noUpdateShop(e) {
        this.$set(this.oneInput,e,true);
        this.$set(this.twoInput,e,true);
      },
      // 详情编辑
      updateShop(fansid,shopname,wangwang,index) {
        let params={
          fansid: fansid,
          shopname: shopname,
          wangwang: wangwang,
        }
        fetch({
          url: "hcm/wechat/updateShop",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$set(this.oneInput,index,true);
            this.$set(this.twoInput,index,true);
            // this.queryInfoDetail(this.updateOpenid)
            // this.theQuery();
          }
        })
      },
      //检查按钮更新事件
      updateConfirm(e) {
        let params={
          fansid: e,
        }
        fetch({
          url: "hcm/wechat/updateConfirm",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.queryInfoDetail(this.updateOpenid)
            this.theQuery();
          }
        })
      },
      //单击表格每一行
      triggerCli(val) {
        console.log(val)
        this.sidebarIndex = 0
        this.queryInfoDetail(val.openid)
      },
      //详情接口
      queryInfoDetail(e) {
        this.updateOpenid = e
        let params={
          openid: e,
        }
        fetch({
          url: "hcm/wechat/queryInfoDetail",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.queryInfoDetailData = data
            for (var i = 0; i < this.queryInfoDetailData.length; i++) {
              this.$set(this.oneInput,i,true);
              this.$set(this.twoInput,i,true);
            }
            if (this.queryInfoDetailData[0].headimgurl) {
              this.queryInfoHeadimgurl = this.queryInfoDetailData[0].headimgurl
            } else {
              this.queryInfoHeadimgurl = ''
            }
            if (this.queryInfoDetailData[0].nickname) {
              this.queryInfoNickname = this.queryInfoDetailData[0].nickname
            } else {
              this.queryInfoNickname = ''
            }
            if (this.queryInfoDetailData[0].shopname) {
              this.sjshopname = this.queryInfoDetailData[0].shopname
            } else {
              this.sjshopname = 0
            }
            if (this.queryInfoDetailData[0].remark) {
              this.queryInfoRemark = this.queryInfoDetailData[0].remark
            } else {
              this.queryInfoRemark = ''
            }
            if (this.queryInfoDetailData[0].shopncount) {
              this.queryInfoShopncount = this.queryInfoDetailData[0].shopncount
            } else {
              this.queryInfoShopncount = ''
            }
            this.centerDialogVisible = true
          } else {
            this.centerDialogVisible = true
          }
        })
        .catch(err => {

        })
      },
      // 表格数据
      theQuery(e) {
        if (e == 1) {
          this.pageNo = 1
          this.currentPage = 0
        }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        if (this.nickname) {
          params.nickname = this.nickname;
        }
        if (this.remark) {
          params.remark = this.remark;
        }
        if (this.shopname) {
          params.shopname = this.shopname;
        }
        if (this.newStatus) {
          params.status = this.newStatus;
        }
        if (this.confirmstatus) {
          params.confirmstatus = this.confirmstatus;
        }
        fetch({
          url: "hcm/wechat/queryWeChatInfo",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.currentPage = 1
            this.tableData = data.content;
            this.totalNum = data.totalElements;
          } else {
            this.currentPage = 1
            this.tableData = '';
            this.totalNum = '';
          }
        })
        .catch(err => {

        })
      },
      //备注
      oneStep(f,nickname,remark) {
        let remark2=remark?remark:nickname
         this.$refs.remark.changeShow(f,remark2)
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery();
      },

    },
    components: {
      pagination,remark,setTags
    }

  }
</script>
<style lang="scss">
#publicAccountUser {
  .page {
    padding: 20px;
    background-color: white;
    min-height: 600px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .el-checkbox-button:first-child .el-checkbox-button__inner {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    -webkit-box-shadow: none!important;
    margin: 5px;
    box-shadow: none!important;
  }
  .el-checkbox-button--mini .el-checkbox-button__inner {
    padding: 7px 15px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    margin: 5px;
  }
  .el-checkbox-button.is-checked .el-checkbox-button__inner {
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    // /* -webkit-box-shadow: -1px 0 0 0 #8cc5ff; */
    // /* box-shadow: -1px 0 0 0 #8cc5ff; */
    }
  .addTagClass {
    border: 1px solid #108cee;
    border-radius: 5px;
    float: left;
    margin: 5px 0px 0px 5px;
    color: #108cee;
    padding: 0 4px 0 4px;
    font-size: 12px;
  }
  .addTagMore {
    float: left;
    margin: 5px 0px 0px 5px;
    color: #108cee;
    padding: 0 4px 0 4px;
    font-size: 12px;
    cursor: pointer;
  }
  .redDot {
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    color: white;
    float: right;
    margin-top: 7px;
  }
  .headBody {
    width: 680px;
    height: 100px;
    background: #fff;
    border-bottom: 1px solid #EBEEF5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    display: flex;
    padding: 20px 30px;
  }
  .box-card {
    margin: 20px 35px;
    padding: 20px 40px;
    font-size: 16px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  #dialog3 {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-dialog__body {
      padding: 10px 20px 20px 20px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
    }
  }
  #dialog2 {
    .el-dialog {
      height: 100%;
      margin-top: none;
      position: fixed;
      right: 0;
      // margin: auto;
      border-radius: 2px;
      -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);
      box-shadow: 0 1px 3px rgba(0,0,0,.3);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      // margin-left: 50%;
      margin-top: 0px !important;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .el-dialog__body {
      padding: 0px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
    }
    .el-dialog__header {
      padding: 0px;
    }
    .el-card, .el-message {
      border-radius: 8px;
      overflow: hidden;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
}
</style>
